export default __webpack_public_path__ + "static/media/EW1613-1.02e37f37.jpg";